export default function collectionHasItems<T>(value: T[] | null | undefined): value is T[] & { length: number } {
	return value != null && value.length > 0;
}
